<template>
    <div class="charge-warp" v-loading="loading">
        <div class="display-f just-b align-i-c">
            <el-form ref="form" :model="searchForm" inline>
                <el-form-item label="就诊日期：">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="searchForm.date" type="daterange"  @change="timeChange"
                        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="医生" v-model="searchForm.doctorName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchForm.channelType" placeholder="渠道" clearable>
                        <el-option label="春堂" :value="80"></el-option>
                        <el-option label="美团" :value="60"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <custom-button type="primary" @click="handleSearch">查询</custom-button>
                    <custom-button type="" @click="handleReset">重置</custom-button>
                </el-form-item>
            </el-form>
            <custom-button type="primary" plain @click="handleExport">导出</custom-button>
        </div>
        <div class="table-warp">
            <el-table :data="tableData" :cell-style="{ borderColor: '#DDDDDD' }" style="width: 100%" border
                height="700px" :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }">
                <el-table-column prop="doctorName" label="医生" width="135"></el-table-column>
                <el-table-column label="待签">
                    <el-table-column prop="staySignNum" label="数量"></el-table-column>
                    <el-table-column prop="staySignAmount" label="金额"></el-table-column>
                </el-table-column>
                <el-table-column label="已签（包含待诊+已诊）">
                    <el-table-column label="数量">
                        <template slot-scope="scope">
                            <div>{{ scope | filterSigned }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="金额">
                        <template slot-scope="scope">
                            <div>{{ scope | filterSignedAmount }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="待诊">
                    <el-table-column prop="staySeeNum" label="数量"></el-table-column>
                    <el-table-column prop="staySeeAmount" label="金额"></el-table-column>
                </el-table-column>
                <el-table-column label="已诊">
                    <el-table-column prop="alreadySeeNum" label="数量"></el-table-column>
                    <el-table-column prop="alreadySeeAmount" label="金额"></el-table-column>
                </el-table-column>
                <el-table-column label="退号">
                    <el-table-column prop="refundNum" label="数量"></el-table-column>
                    <el-table-column prop="refundAmount" label="金额"></el-table-column>
                </el-table-column>
                <el-table-column label="停诊">
                    <el-table-column prop="suspendNum" label="数量"></el-table-column>
                    <el-table-column prop="suspendAmount" label="金额"></el-table-column>
                </el-table-column>
            </el-table>

        </div>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import { statementDTO, CommonDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { isMoreThanOneYear, debounce, isEmptyArray } from '@/utils/validateBase'
export default {
    // 定义引入的组件
    components: { customTable },
    props: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今日',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨日',
                    onClick(picker) {
                        let yesterday = moment().subtract(1, 'days')
                        const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本周',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本月',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本年',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                ]
            },
            searchForm: {
                date: [],
                doctorName: '',
                channelType: '',
                pageNum: 1,
                pageSize: 500
            },//搜索条件
            tableData: [],//表格数据
            total: 0,//总数
            pageNumTotal: 0,//分页总页数
            statisticsObj: {},//统计对象
            sum: [],//总计
            loading: false,
        }
    },
    //变量监听
    watch: {},
    filters: {
        filterSigned(row) {
            return Utils.bigNumber(row.row.staySeeNum, '+', row.row.alreadySeeNum)
        },
        filterSignedAmount(row) {
            return Utils.bigNumber(row.row.staySeeAmount, '+', row.row.alreadySeeAmount)
        },
    },
    // 页面初始化
    async created() {
        let time = CommonDTO.getSystemTimeDTO()
        let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
        let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
        this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
        this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
        this.getData()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 重置
         */
        handleReset() {
            this.searchForm = {
                date: [],
                doctorName: '',
                channelType: '',
                pageNum: 1,
                pageSize: 20
            }
            let startOfDay = Number(Utils.startOfDay(this.$moment()))
            let endOfDay = Number(Utils.endOfDay(this.$moment()))
            this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
            this.getData()
        },

        /**
         * 搜索
         */
        handleSearch: debounce(async function () {
            let HH = this.$moment().get('hour')
            this.searchForm.pageNum = 1
            // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
            // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
            let flag = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
            if (flag) return this.$message.error('时间范围不能超过一年')
            this.getData()
        }, 1000, true),
        /**
         * 获取分页、统计数据
         */
        async getData() {
            this.searchForm.startTime = Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.stopTime = Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
            this.queryRegSetl();
        },

        /**
         * 查询挂号结算
         */
        async queryRegSetl() {
            this.loading = true
            this.tableData = []
            let { code, rows, total } = await statementDTO.queryRegSetl(this.searchForm)
            if (code == 200) {
                this.tableData = this.searchForm.pageNum == 1 ? rows : [...this.tableData, ...rows]
                this.total = total
                this.pageNumTotal = Math.ceil(total / this.searchForm.pageSize)
                this.getRegSetlNum()

            } else {
                this.loading = false
            }
        },
        /**
         * 查询挂号结算统计
         */
        async getRegSetlNum() {
            let { code, data } = await statementDTO.getRegSetlNum(this.searchForm)
            if (code == 200) {
                // this.statisticsObj = data
                this.loading = false
                if (!isEmptyArray(this.tableData)) this.tableData.push({ doctorName: '合计', ...data });
            } else {
                this.loading = false
            }
        },
        /**
        * 导出
        */
        handleExport: debounce(function () {
            this.searchForm.startDate = Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.endDate = Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
            statementDTO.exportRegSetl(this.searchForm, { name: '挂号结算' }).then(res => { })
        }, 1000, true),
        /**
         * 时间选择器改变
         */
         timeChange(val){
            val[0]= Utils.timeFormat(Number(Utils.startOfDay(val[0])), 'yyyy-MM-DD HH:mm:ss')
            val[1] = Utils.timeFormat(Number(Utils.endOfDay(val[1])), 'yyyy-MM-DD HH:mm:ss')
         }
    },
}
</script>
<style lang="less" scoped>
.charge-warp {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .el-form-item {
        margin-bottom: 0;
    }

    .table-warp {
        margin-top: 16px;
        flex: 1;
        overflow: auto;

        /deep/.el-table {
            border-color: #DDDDDD;
        }

        /deep/.pagination-wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 0;

            .total-tips {
                color: #667182;
                font-size: 14px;
            }
        }

        /deep/.el-table__row {
            &:last-child {
                font-weight: bold;
            }
        }
    }
}</style>